// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--OCJMX","tags":"tags--2AQMi","scroll":"scroll--dmtHL","padded":"padded--DKBUD"};